    <template>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onCreate"
    >
        <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Название"
                name="name"
                required
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            :disabled="!valid || isFetch"
            color="success"
            class="mr-4 mt-4"
            type="submit"
        >
            Создать
        </v-btn>
    </v-form>
</template>

<script>
import * as api from '@/api/workspace';
import {mapActions} from 'vuex';
export default {
    name: "WorkSpaceCreate",
    data() {
        return {
            isFetch: false,
            valid: true,
            name: '',
            nameRules: [
                v => !!v || 'Название обязательно к заполнению',
            ],
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        ...mapActions('workspaceList', ['LOAD_WORKSPACES']),
        async apiCreate(form){
            this.isFetch = true;
            try{
                let {data} = await api.create(new FormData(form));
                this.SHOW_SUCCESS('Пространство успешно создано');
                this.$refs.form.reset();
                return data.data;
            }catch (e) {
                console.log(e);
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка создания пространства'});
                return Promise.reject();
            }finally {
                this.isFetch = false;
            }
        },
        async onCreate(e){
            if( ! this.$refs.form.validate() ){
                return Promise.reject();
            }
            let result = await this.apiCreate(e.target)
            this.LOAD_WORKSPACES();
            this.$emit('created', result);
        }
    }
}
</script>